var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"body body-login"},[_c('div',{staticClass:"vt-wrapper gray-background"},[_c('div',{staticClass:"vt",staticStyle:{"background-color":"#000000c2"}},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }